import { PermissionType } from "@store/session/types";
import listPermissionsForStream from "./listPermissionsForStream";
import { listUsersAndStreamsMapping } from "./listUsersAndStreamsMapping";
import listPermissionsForCompany from "./listPermissionsForCompany";
import listPermissionsForSite from "./listPermissionsForSite";

export interface IPermissionsAPI {
  listPermissionsForStream(userId: string, companyId: string, siteId: string, kvsName: string): Promise<{ kvsName: string, permissions: PermissionType[] }>;
  listPermissionsForSite(userId: string, companyId: string, siteId: string): Promise<{ kvsName: string, permissions: PermissionType[] }[]>;
  listPermissionsForCompany(userId: string, companyId: string): Promise<{ kvsName: string, permissions: PermissionType[] }[]>;
  listUsersAndStreamsMapping(companyId: string): Promise<Map<string, string[]>>;
}

const Permissions: IPermissionsAPI = {
  listPermissionsForStream,
  listUsersAndStreamsMapping,
  listPermissionsForCompany,
  listPermissionsForSite
}

export default Permissions;
